import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { Autocomplete, Box, Checkbox, TextField, type AutocompleteProps } from '@mui/material';
import { namedByPlaceholder } from '~/components/forms/autocomplete-label';
import { useSettingIds } from '~/components/settings';

interface TagsAutocompleteProps {
  options: string[];
  value: string[];
  onChange: AutocompleteProps<string, true, false, true>['onChange'];
  placeholder?: string;
}

export const TagsAutocomplete = ({
  options,
  value,
  onChange,
  placeholder,
}: TagsAutocompleteProps) => {
  const ids = useSettingIds();

  return (
    <Autocomplete
      id={ids?.inputId}
      multiple
      autoHighlight
      disableCloseOnSelect
      freeSolo
      options={options}
      value={value}
      onChange={onChange}
      getOptionLabel={(option) => option}
      isOptionEqualToValue={(option, value) => option === value}
      renderOption={(props, option, { selected }) => (
        <Box component="li" {...props}>
          <Checkbox
            icon={<CheckBoxOutlineBlank fontSize="small" />}
            checkedIcon={<CheckBox fontSize="small" />}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option}
        </Box>
      )}
      renderInput={(params) => (
        <TextField {...namedByPlaceholder(params, placeholder, ids != null)} />
      )}
    />
  );
};
